/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomAppState } from "@stoneage/App/Store/Reducers";

type Parameter = {
    filterType:
        | "OnlyShowMyProducts"
        | "PageNumber"
        | "PageSize"
        | "SortType"
        | "Application"
        | "DocumentTypes"
        | "ProductLines"
        | "OnlyShowActiveDocuments"
        | "OnlyShowDiscontinuedDocuments"
        | "Query";
    value: string;
};

type HandlerType = Handler<Parameter, {}>;

export const RemoveApplicationsFilter: HandlerType = props => {
    if (props.parameter.filterType === "Application") {
        const applicationFilter = (props.getState() as CustomAppState).xProductInfo.filters.applications;
        const newFilteredFacets = applicationFilter?.filter(facet => facet !== props.parameter.value);
        props.dispatch({
            type: "Pages/ProductInformation/RemoveFilter",
            name: props.parameter.filterType,
            value: newFilteredFacets,
        } as any);
    }
};

export const RemoveDocumentTypesFilter: HandlerType = props => {
    if (props.parameter.filterType === "DocumentTypes") {
        const documentsFilter = (props.getState() as CustomAppState).xProductInfo.filters.documentTypes;
        const newFilteredFacets = documentsFilter?.filter(facet => facet !== props.parameter.value);
        props.dispatch({
            type: "Pages/ProductInformation/RemoveFilter",
            name: props.parameter.filterType,
            value: newFilteredFacets,
        } as any);
    }
};

export const RemoveProductLinesFilter: HandlerType = props => {
    if (props.parameter.filterType === "ProductLines") {
        const productLineFilter = (props.getState() as CustomAppState).xProductInfo.filters.productLines;
        const newFilteredFacets = productLineFilter?.filter(facet => facet !== props.parameter.value);
        props.dispatch({
            type: "Pages/ProductInformation/RemoveFilter",
            name: props.parameter.filterType,
            value: newFilteredFacets,
        } as any);
    }
};

export const RemoveQueryFilter: HandlerType = props => {
    if (props.parameter.filterType === "Query") {
        props.dispatch({
            type: "Pages/ProductInformation/RemoveFilter",
            name: props.parameter.filterType,
            value: "",
        } as any);
    }
};

export const chain = [RemoveApplicationsFilter, RemoveDocumentTypesFilter, RemoveProductLinesFilter, RemoveQueryFilter];

const removeProductInformationFilter = createHandlerChainRunner(chain, "RemoveProductInformationFilter");
export default removeProductInformationFilter;
